import {
  Component,
  ElementRef,
  ViewChild,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy
} from "@angular/core";
import { MatSelectChange } from "@angular/material/select";
import { ICdnUserData} from '../add-user/cdnuser';
import { AddUserService } from '../services/adduser.services';
import { MatDialog, MatDialogRef} from '@angular/material/dialog';
import { FormGroup, FormControl } from '@angular/forms';
import {MatTableDataSource} from '@angular/material/table';
import { MatSort} from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { IUserData } from '../add-user/cdnuser';
import { HttpErrorResponse } from '@angular/common/http';
import {MatMenuTrigger} from '@angular/material/menu';
import {ConfirmDialogComponent} from '../../shared/confirm-dialog/confirm-dialog.component';
import {UserProfileComponent} from '../components/user-profile/user-profile.component';
import { IUserProfile } from '../components/user-profile/user-profile';
import { AuthService } from 'src/app/user/services/auth.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'] 
})
export class AddUserComponent implements OnInit, OnDestroy {

  private subs = new Subscription();

  displayedColumns: string[] = ['name', 'email', 'profile','isActive', 'lastLogInTime', 'options'];
  
  public dataSource: MatTableDataSource<IUserData>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  private dataArray: any;

  public userForm:FormGroup; 
  errorMessage = '';
  searchVal:string = '';
  addUserVal:string = '';

  @ViewChild("searchRef") searchTextInput: ElementRef;
  @Output() sendMarkerData = new EventEmitter<any>();
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  // user Search related
  searchInput = new FormControl("");
  filteredOptions: ICdnUserData[]; 
  selectedUser = false;
  userData;
  
  optionsList: string[] = [
    "Change Status",
    "Change Profile",
    "Delete"
  ];

  profiles: IUserProfile[];  
  selectedProfile: number; 
  showUserProfileDialog;

  constructor(private addUserService: AddUserService,
              private dialogRef: MatDialogRef<AddUserComponent>,
              private confirmDialog : MatDialog,
              private userProfileDialog : MatDialog,
              private router: Router, 
              private authService: AuthService) {}

  ngOnInit() {
    this.loadAllUserData();
  }

  loadAllUserData() {
    this.addUserService.getCDNUserData().subscribe((res) => {
        this.dataArray = res;
        this.dataSource = new MatTableDataSource<IUserData>(this.dataArray);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    },
      (err: HttpErrorResponse) => {
        if(err.status == 401) {
          this.authService.logout();
          this.dialogRef.close();
          this.router.navigate(['/user/login']);
        } else {
            (err) => console.log("Error while get CDN user data: ", err)
          }          
        }
      )
  }

  ngOnChanges(){
    this.loadAllUserData();
  }

  displayFn(searchItem: any): string {
    return searchItem && searchItem.fullName
      ? searchItem.fullName
      : "";
  }  
  
  filterSearch(name: string) {    
    if(name.length >=3) {  
    this.addUserService.getCDNUserSearch(name).subscribe(
      (res: any) => {
          this.filteredOptions = res.list;       
      },
      (_: any) => {
        this.filteredOptions = [];
      }
    );

    this.searchInput.valueChanges.subscribe((searchValue: string) => {
      if (searchValue === "") {
        this.filteredOptions = [];
      }
    });
  }
}
  onSearchSelect(option: MatSelectChange) {
    this.selectedUser = true;
    this.searchTextInput.nativeElement.blur();
    this.sendMarkerData.emit(option.value);

    //create new user
    const payload = {
      email: option.value.email,
      firstName: option.value.firstName,
      lastName: option.value.lastName,
      isActive: "true",
      action: "save"
    }
    this.userData = payload;
  }
  addUser(): void {
    this.showUserProfileDialog == true;
    const userProfiledialogRef = this.userProfileDialog.open(UserProfileComponent, {
      width: '30rem',
      data: this.userData,
      disableClose :false,
    });   
    userProfiledialogRef.afterClosed().subscribe(result => {
     this.loadAllUserData();   
     this.addUserVal = '';
     this.searchVal = '';
    })
  }

  // openSnackBar(message: string) {
  //   this.snackBar.open(message, 'close', {
  //     duration: 10000,
  //     verticalPosition: 'top'
  //   });
  // }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  updateStatus(value: any, element: any) {
    let message: string;
    let width: string;

    if (element.isActive == "true") {
      message = "You want to deactivate the user?";
      width = "28rem";
    }
    else {
      message = "You want to activate the user?";
      width = "25rem";
    }

    const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
      width,
      data: message,
      disableClose: false
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.saveData) {     
        this.addUserService.updateStatus(element).subscribe((res:any) => {    
          if(res.responseStatus === 'Success') {
            this.searchVal = '';
            this.loadAllUserData();    
          } else if (res.responseCode != null && res.responseCode.statusCode === 401) {
              this.authService.logout();
              this.router.navigate(['/user/login']);
            } 
        },
        (err: HttpErrorResponse) => {
          console.log(err);
        });
      }
    })
  }

  changeProfile(value: any, element: any) {
    //create new user
    const payload = {
      email: element.email,
      action: "update"
    }
    this.userData = payload;

    const userProfiledialogRef = this.userProfileDialog.open(UserProfileComponent, {
      width: '30rem',
      data: this.userData,
      disableClose :false,
    });   
    userProfiledialogRef.afterClosed().subscribe(result => {
     this.loadAllUserData();   
     this.searchVal = '';
    })
  }

  deleteUser(value: any, element: any) {
    let message: string;
    let width: string;
   
    message = "Do you want to delete this user? You won't be able to revert this!";
    width = "28rem";  

    const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
      width,
      data: message,
      disableClose: false
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.saveData) {   
        this.addUserService.deleteUser(element).subscribe((res:any) => {   
          if (res.responseStatus === "Success") {
            this.loadAllUserData();  
            this.searchVal = '';
          } else if (res.responseCode != null && res.responseCode.statusCode === 401) {
              this.authService.logout();
              this.router.navigate(['/user/login']);
            }    
        },
          (err: HttpErrorResponse) => {
            console.log(err);
          });
        }
      })
    }

  closeDialog(): void {
    this.dialogRef.close();
  }
  ngOnDestroy() {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }

  saveProfile(): void {
    //console.log(this.selectedProfile);
   }
  cancel(): void {
    this.showUserProfileDialog == false;
  }
}
